<template>
  <div class="myworkThree">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>我的工作
      </span>
      <span class="other more"></span>
    </div>
    <div class="myworkThree-main">
      <div class="itemline" v-for="(item,index) in tabname" :key="index">
        <div class="first-col">
          <svg-icon :icon-class="item.iconame" class="iconstyle"></svg-icon>
          <span class="span">{{item.typeName}}</span>
        </div>
        <div class="itemText" @click="jumpToRouter(item.router1)">{{item.taskName1}}</div>
        <div class="itemText" @click="jumpToRouter(item.router2)">{{item.taskName2}}</div>
        <div class="itemText" @click="jumpToRouter(item.router3)">{{item.taskName3}}</div>
        <div class="itemText" @click="jumpToRouter(item.router4)">{{item.taskName4}}</div>
        <div class="itemText" @click="jumpToRouter(item.router5)">{{item.taskName5}}</div>
        <div class="itemText" @click="jumpToRouter(item.router6)">{{item.taskName6}}</div>
        <div class="itemText" @click="jumpToRouter(item.router7)">{{item.taskName7}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
export default {
  components: {},
  props: {},
  data() {
    return {
      tabname: [
        {
          iconame: 'Institutions',
          typeName: '机构管理',
          taskName1: '机构管理',
          router1: '/queryOrganMge'
        },
        {
          iconame: 'putOnRecord',
          typeName: '备案管理',
          taskName1: '物业服务合同备案',
          router1: '/propertyContractRecord',
          taskName2: '业主委员会备案',
          router2: '/ownerCommitteeRecord'
        },
        {
          iconame: 'putOnRecord',
          typeName: '物业管理',
          taskName1: '物业区域管理',
          router1: '/queryPropertyArea'
        }
      ],
      Position: 'running'
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {},
  mounted() {},
  methods: {
    jumpToRouter(router) {
      this.$router.push(router);
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.myworkThree {
  background-color: #fff;
  .index-header {
    .more {
      color: blue;
    }
  }
  .myworkThree-main {
    background-color: #fff;
    min-height: 210px;
    overflow: hidden;
    .itemline {
      margin: 10px;
      margin-top: 25px;
      height: 50px;
      background-color: #f5f5f5;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .itemText {
        cursor: pointer;
        min-width: 160px;
        height: 17px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        width: 12.5%;
      }
      .first-col {
        min-width: 140px;
        width: 12.5%;
        margin-left: 20px;
        height: 17px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        .span {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>